module.exports = __webpack_public_path__ + "static/img/logo_login_mmjp.d869fdc9.png";